
// const target     = document.getElementById('header');
// let height     = document.getElementById('menu').clientHeight;
// let offset       = 0,
// 	lastPosition = 0,
// 	ticking      = false;

// function onScroll() {
// 	if (lastPosition > height) {
// 		if (lastPosition > offset) {
// 			target.classList.add('head-up');
// 		} else {
// 			target.classList.remove('head-up');
// 		}
// 		offset = lastPosition;
// 		target.classList.add('head-over');
// 	} else {
// 		target.classList.remove('head-over');
// 	}
// }

// window.addEventListener('scroll', function(e) {
// 	lastPosition = window.scrollY;
// 	if (!ticking) {
// 		window.requestAnimationFrame(function() {
// 			onScroll(lastPosition);
// 			ticking = false;
// 		});
// 		ticking = true;
// 	}
// });

/**
 * グローバルナビのクローンを生成
 */
function setCloneHead() {
	const body = document.body;
	let header = document.getElementById('header');

	if(!header) return;

	let cloneHead = header.cloneNode(true);
	cloneHead.id = 'header-clone';

	cloneHead.classList.remove('header');
	cloneHead.classList.add('header-clone');

	body.insertBefore(cloneHead, body.firstChild);

}
setCloneHead();

function setCloneMenu() {
	const body = document.body;
	let header2 = document.getElementById('header-clone');
	// let logo = header2.firstElementChild;
	let btn = document.querySelector("#header-clone #open-menu");
	let globalNav = header2.lastElementChild;


	if(!header2) return;
	btn.id = 'open-menu-clone';
	globalNav.id = 'menu-clone';
}
setCloneMenu();

/**
 * グローバルナビのクローンをページ上部に移動・固定
 */
function fixedGlobalNav() {
	let scrollY = window.pageYOffset;
	// let trigger = document.getElementById('setup');
	let trigger = 300;
	let cloneNav = document.getElementById('header-clone');

	if(!cloneNav) return;

	// let triggerClientRect = trigger.getBoundingClientRect();
	// let triggerY = scrollY + triggerClientRect.top;
	// let triggerY = scrollY + trigger;
	if(scrollY > trigger) {
		cloneNav.classList.add('is-fixed-head');
	} else {
		cloneNav.classList.remove('is-fixed-head');
	}
}
window.addEventListener('scroll', fixedGlobalNav);